/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetSalesInvoicePaymentSummaryDto
 */
export interface GetSalesInvoicePaymentSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof GetSalesInvoicePaymentSummaryDto
     */
    totalPaid: number;
    /**
     * 
     * @type {number}
     * @memberof GetSalesInvoicePaymentSummaryDto
     */
    grossAmount: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetSalesInvoicePaymentSummaryDto
     */
    currentBalance: number | null;
    /**
     * 
     * @type {Date}
     * @memberof GetSalesInvoicePaymentSummaryDto
     */
    paymentDueDate: Date | null;
}

/**
 * Check if a given object implements the GetSalesInvoicePaymentSummaryDto interface.
 */
export function instanceOfGetSalesInvoicePaymentSummaryDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "totalPaid" in value;
    isInstance = isInstance && "grossAmount" in value;
    isInstance = isInstance && "currentBalance" in value;
    isInstance = isInstance && "paymentDueDate" in value;

    return isInstance;
}

export function GetSalesInvoicePaymentSummaryDtoFromJSON(json: any): GetSalesInvoicePaymentSummaryDto {
    return GetSalesInvoicePaymentSummaryDtoFromJSONTyped(json, false);
}

export function GetSalesInvoicePaymentSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSalesInvoicePaymentSummaryDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalPaid': json['totalPaid'],
        'grossAmount': json['grossAmount'],
        'currentBalance': json['currentBalance'],
        'paymentDueDate': (json['paymentDueDate'] === null ? null : new Date(json['paymentDueDate'])),
    };
}

export function GetSalesInvoicePaymentSummaryDtoToJSON(value?: GetSalesInvoicePaymentSummaryDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalPaid': value.totalPaid,
        'grossAmount': value.grossAmount,
        'currentBalance': value.currentBalance,
        'paymentDueDate': (value.paymentDueDate === null ? null : value.paymentDueDate.toISOString()),
    };
}

